import { render, staticRenderFns } from "./CallUsLink.vue?vue&type=template&id=5d52951a&"
import script from "./CallUsLink.vue?vue&type=script&lang=js&"
export * from "./CallUsLink.vue?vue&type=script&lang=js&"
import style0 from "./CallUsLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports